import apis from "../../../api";
import { errorTypes } from "../../../utils/errorTypes";
import { setErrorHandler } from "./errorActionHandler";

export const getUserClassInfoActionHandler = () => async () => {
  return await apis.reports.graphicalReports
    .getUserDistributionSummary()
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getClassInfoActionHandler = () => async () => {
  return await apis.reports.graphicalReports
    .getClassDistributionSummary()
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
export const getTrendingClassesActionHandler = () => async () => {
  return await apis.dashboard
    .getTrendingClasses()
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getUsersStatusActionHandler = () => async () => {
  return await apis.admin.userManagement
    .getUsersStatus()
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};